import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color } from '@figure/frontlib-gui';

const Separator = styled.div.attrs(({ className }) => ({
  className: className || '',
}))`
  border-bottom: 1px solid ${(props) => props.color};
  margin: ${(props) => props.margin}px 0;
`;

const Element = ({ margin, color, className }) => <Separator margin={margin} color={color} className={className} />;

Element.propTypes = {
  /**
   * Top and bottom margins in pixels.
   */
  margin: PropTypes.number,
  /**
   * Line color.
   */
  color: PropTypes.string,
  /**
   * For additional styling
   */
  className: PropTypes.string,
};

Element.defaultProps = {
  margin: 24,
  color: Color.LINE_GREY,
  className: '',
};

export default Element;
